/** Standard API error codes from 05_API_CONTRACT.md */
export const ApiErrorCode = {
    INVALID_CREDENTIALS: "INVALID_CREDENTIALS",
    AUTH_REQUIRED: "AUTH_REQUIRED",
    ACCESS_DENIED: "ACCESS_DENIED",
    UNIT_SCOPE_DENIED: "UNIT_SCOPE_DENIED",
    EXPENSE_INVALID_STATUS: "EXPENSE_INVALID_STATUS",
    EXPENSE_SELF_APPROVAL: "EXPENSE_SELF_APPROVAL",
    INSUFFICIENT_BANK_BALANCE: "INSUFFICIENT_BANK_BALANCE",
    INSUFFICIENT_FUND_BALANCE: "INSUFFICIENT_FUND_BALANCE",
    PAYMENT_EXCEEDS_UNPAID: "PAYMENT_EXCEEDS_UNPAID",
    PAYMENT_BEFORE_APPROVAL: "PAYMENT_BEFORE_APPROVAL",
    ALLOCATION_TOTAL_MISMATCH: "ALLOCATION_TOTAL_MISMATCH",
    CLOSED_PERIOD: "CLOSED_PERIOD",
    DUPLICATE_SUBMISSION: "DUPLICATE_SUBMISSION",
    FILE_ACCESS_DENIED: "FILE_ACCESS_DENIED",
    VALIDATION_ERROR: "VALIDATION_ERROR",
    INTERNAL_ERROR: "INTERNAL_ERROR",
    NOT_FOUND: "NOT_FOUND",
};
/** User roles defined in 01_PRODUCT_SCOPE_AND_WORKFLOWS.md */
export const UserRole = {
    SUPER_ADMIN: "super_admin",
    ACCOUNTS: "accounts",
    FINANCE_REVIEWER: "finance_reviewer",
    BOARD_MEMBER: "board_member",
    PROJECT_LEAD: "project_lead",
    AUDITOR: "auditor",
    DONOR: "donor",
};
//# sourceMappingURL=index.js.map